import React from "react";

import ApprovedVideoIcon from "../../public/assets/icons/ApprovedVideoIcon";
import WebsiteIcon from "../../public/assets/icons/WebsiteIcon";
import RejectedVideoIcon from "../../public/assets/icons/RejectedVideoIcon";
import { List, ListItem, Typography } from "@mui/material";

import styels from "../../styles/components/reviewsvideosmenu.module.scss";
import { Box } from "@mui/system";
import WebsiteIconTwo from "../../public/assets/icons/WebsiteIconTwo";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { parseCookies } from "nookies";
import { usePost } from "../../hooks/api/useFetch";

export default function ReviewdVideoMenu() {
    const { pathname } = useLocation();

    const cookies = parseCookies();
    const userData = JSON.parse(cookies?.userdetails || "{}");

    const {
        data: managerSubmissionsData,
        isLoading: managerSubmissionsIsLoading,
        isSuccess: managerSubmissionsIsSuccess,
    } = usePost(["manager-submissions", userData?.id], "manager/submissions", {
        user_id: userData.id,
    });
    
    return (
        <List className={styels.video_nav} disablePadding>
            <ListItem disablePadding>
                <Link
                    to={"/manager-dashboard/reviewd-videos"}
                    className={
                        pathname == "/manager-dashboard/reviewd-videos"
                            ? `${styels.linkActive}`
                            : ""
                    }
                >
                    <Typography variant="caption" className={styels.icon}>
                        <ApprovedVideoIcon />
                    </Typography>
                    <Box className={styels.menu_rght}>
                        <Typography variant="body2">Approved Videos</Typography>
                        <Typography variant="caption">
                            {managerSubmissionsData?.data?.data?.reviewed_videos
                                ?.approved
                                ? managerSubmissionsData?.data?.data
                                      ?.reviewed_videos?.approved
                                : "-"}
                        </Typography>
                    </Box>
                </Link>
            </ListItem>
            <ListItem disablePadding>
                <Link
                    to={"/manager-dashboard/reviewd-videos-website"}
                    className={
                        pathname == "/manager-dashboard/reviewd-videos-website"
                            ? `${styels.linkActive}`
                            : ""
                    }
                >
                    <Typography variant="caption" className={styels.icon}>
                        <WebsiteIconTwo />
                    </Typography>
                    <Box className={styels.menu_rght}>
                        <Typography variant="body2">Website Only</Typography>
                        <Typography variant="caption">
                            {managerSubmissionsData?.data?.data?.reviewed_videos
                                ?.website_only
                                ? managerSubmissionsData?.data?.data
                                      ?.reviewed_videos?.website_only
                                : "-"}
                        </Typography>
                    </Box>
                </Link>
            </ListItem>
            <ListItem disablePadding>
                <Link
                    to={"/manager-dashboard/reviewd-videos-rejected"}
                    className={
                        pathname == "/manager-dashboard/reviewd-videos-rejected"
                            ? `${styels.linkActive}`
                            : ""
                    }
                >
                    <Typography variant="caption" className={styels.icon}>
                        <RejectedVideoIcon />
                    </Typography>
                    <Box className={styels.menu_rght}>
                        <Typography variant="body2">Rejected Videos</Typography>
                        <Typography variant="caption">
                            {managerSubmissionsData?.data?.data?.reviewed_videos
                                ?.rejected
                                ? managerSubmissionsData?.data?.data
                                      ?.reviewed_videos?.rejected
                                : "-"}
                        </Typography>
                    </Box>
                </Link>
            </ListItem>
        </List>
    );
}
